<template>
	<div
		class="tr"
		:class="{disabled: entry.disabled }"
	>
		<div
			v-if="canSelect"
			class="td checkbox-wrapper"
		>
			<Checkbox
				:id="entry.id"
				:value="checked"
				:theme="`dark`"
				:class="{ 'is-visible': isCheckboxVisible }"
				:size="`small`"
				@change="handleSelect"
			/>
		</div>
		<div
			v-else
			class="td spacer"
		/>
		<div
			v-for="col in columns"
			:key="`data-${entry.id}-${col.key}`"
			class="td"
			:class="{
				'text-right': col.key === 'time' || col.key === 'duration',
				'options text-right': col.key === 'options',
			}"
			:style="`width: ${col.size}%`"
			@click="handleRowClick(entry)"
		>
			<span
				v-if="col.key !== 'options'"
				:class="{
					'action-name': col.key === 'action',
				}"
			>
				<slot
					:name="`col-${col.key}`"
					:entry="entry"
					:col="col"
				>
					{{ entry[col.key] }}
				</slot>
			</span>
			<!-- item options cell -->
			<div
				v-else-if="hasContextMenu"
				class="row-actions"
			>
				<slot
					name="row-actions"
					:menu-items="menuItems"
					:entry="entry"
				>
					<ContextMenu
						:key="`context_menu${entry.id}`"
						:menu-items="menuItems"
						:value="entry"
					>
						<template #toggle>
							<span class="sc-white">
								<Icon
									icon-name="context-menu"
									size="md"
								/>
							</span>
						</template>
					</ContextMenu>
				</slot>
			</div>
		</div>

		<slot
			name="row-extra"
			:entry="entry"
		/>
	</div>
</template>

<script>
import Checkbox from '@components/checkbox/Checkbox';
import Icon from '@components/Icon';
import ContextMenu from '@components/context-menu/ContextMenu.vue';

export default {
	name:       'TagRow',
	components: { Checkbox, Icon, ContextMenu },
	props:      {
		entry: {
			type:    Object,
			default: null,
		},
		canSelect: {
			type: Boolean,
		},
		sportName: {
			type:    String,
			default: '',
		},
		columns: {
			type:    Array,
			default: () => [],
		},
		checkboxAlwaysVisible: {
			type:    Boolean,
			default: true,
		},
		checked: {
			type:    Boolean,
			default: false,
		},
		menuItems: {
			type:    Array,
			default: null,
		},
	},
	data() {
		return {
			imageLoadingError: false,
		};
	},
	computed: {
		isCheckboxVisible() {
			return this.checkboxAlwaysVisible || this.checked;
		},
		hasContextMenu() {
			return this.menuItems?.length > 0;
		},
	},
	watch: {
		checked(value) {
			this.isChecked = value;
		},
	},
	methods: {
		handleSelect(value) {
			this.$emit('selection-changed', { entry: this.entry, selected: value });
		},
		handleRowClick(entry) {
			if (this.entry.disabled) {
				return;
			}
			this.$emit('row-click', entry);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.tr {
	&.disabled {
		color: var(--color-grey-700);
		@media (hover: hover)  {
			&:hover {
				cursor: initial;
			}
		}
	}

	.td.options {
		width: auto;
		flex-grow: 1;
	}
}

.actions-spacing {
	margin-left: 12px;
}

.row-actions {
	display: flex;
	justify-content: flex-end;
}

</style>
